import $http from '$http'
import {
    lg,
    util
} from 'utils';

export default {
    methods: {
        RePayMentMoneyAdd() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            $http.post('api/AgentLend/RePayMentMoneyAdd', Object.assign({}, params, this.form)).then(res => {
                let {
                    Data
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '还款成功',
                        type: 'success'
                    });
                    this.$emit('getTableList')
                    this.$emit('getTotal')
                    this.dialogClose()

                });
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/Agent/AgentLend/components/repayment/services.js